<template>
  <div>
    <div class="content-block">
      <h1>Developer</h1>
      <p>
        My core skills are:
      </p>
      <ul>
        <li>JavaScript</li>
        <li>HTML5</li>
        <li>git</li>
        <li>NodeJS</li>
        <li>PostCSS, Sass or SCSS</li>
        <li>gulp</li>
        <li><i title="a way of structuring large scale CSS">BEM</i></li>
        <li>Jasmine / Karma</li>
        <li>AngularJS</li>
        <li>Silverstripe (a PHP framework and CMS)</li>
        <li>Database design</li>
      </ul>
      <p>
        I also like to use D3.js for data visualization, write JS in ES6 and then transpile it, make fast backends with
        PHP, create thorough requirements engineering, keep code clean, do code reviews, use VueJS or React and Phaser.io.
        When it comes to template engines, the simpler, the better - that is why I like Handlebars.
        I also still know my way around in mercurial and the ionic framework. I also have experience in moving projects
        forward from legacy frameworks like bower or grunt to more modern technologies. I am comfortable with
        test-driven development and find that code reviews always make a project better.
      </p>
    </div>
    <div class="content-block">
      <h2>My work experience as a developer:</h2>
      <h3>
        <time>01/2018 - today</time>
      </h3>
      <p>
        <strong>Frontend Developer at Netzkontor Nord, Flensburg</strong><br>
        Developing and maintaining business software for multiple public services, that offer glass fiber connections to their
        communities. Glass fiber is an incredibly interesting technology. In the state of Schleswig-Holstein it has huge momentum,
        so there is a demand for modern applications to handle customer relations and interfaces to telecommunication systems.
        The superstructure is driven by many public services, big and small, instead of only one or two big players, which creates
        great opportunities for a company that is supporting all of these clients with knowledge, planning and software.
      </p>
      <h3>
        <time>02/2016 - 12/2017</time>
      </h3>
      <p>
        <strong>Frontend Developer at PublicisPixelpark, Berlin</strong><br>
        Leading the frontend team for a large project. The backend is an Adobe Experience Manager application with
        various services connected. It is a challenging and very modern project. My goal was to keep the frontend
        maintainable, fast, sturdy and beautiful. Modularization was the key component in accomplishing that. Neat
        documentation and optimized processes helped in delivering on time and making our client happy.
      </p>
      <h3>
        <time>10/2014 - 01/2016</time>
      </h3>
      <p>
        <strong>Frontend Developer at eThinking, Berlin</strong><br>
        I helped this startup, consisting of very skilled Java developers, to make administrative webapps for big media
        clients and websites and apps for their publications. Custom realtime analytics tools for millions of page
        impression a day, managing thousands of assets in a simple way for editors and building a modular news app are
        just some of the goals we accomplished together. Our fast and flexible approaches made sure we always had a way
        to tackle upcoming challenges, provide growth to the company and still had the time to build open source
        solutions, while doing so. We also built a push notification service, that challenges even the fastest big
        players in the world.
      </p>
      <h3>
        <time>07/2014 - today</time>
      </h3>
      <p>
        <strong>Freelance Developer</strong><br>
        A few happy clients trust me with their whole projects, for multiple years now. Others seek short-term aid and
        consultation from me. I am always excited to hear about your project.
      </p>
      <h3>
        <time>08/2012 - 09/2014</time>
      </h3>
      <p>
        <strong>Developer at ennit interactive, Kiel</strong><br>
        Building beautifully and individually designed websites for many clients, big and small, in the hotel industry
        and web shops. I crafted professional and easy-to-use CMSes to be used by the clients' staff and tailored to
        their editing and marketing needs. I was also deeply involved in planning a custom architecture and running the
        technical project management for an online shopping solution of a european market leader, who today surpasses
        it's competitors.
      </p>
    </div>
    <div class="content-block">
      <p>
        If you would like to get an even more detailed look at my career, have a look at my
        <a href="https://www.xing.com/profile/Merten_Hanisch" target="_blank">Xing profile</a>.<br>
        Or ask me any questions you have directly:
        <a href="mailto:merten.hanisch@gmail.com">merten.hanisch@gmail.com</a>.
      </p>
    </div>
    <div class="content-block">
      <p>
        Also check out my side-projects as a game developer at <a href="http://mortal.host" target="_blank">Mortal Host</a>.
      </p>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'developer'
  }
</script>



// WEBPACK FOOTER //
// developer.vue?76a35754